<sesio-chart kind="highstock" [options]="options" (ready)="buildSeries($event)">
</sesio-chart>
